<template>
  <div>
    <v-card class="elevation-7 card-style">
      <v-card-title primary-title class="justify-center">
        <v-layout row wrap justify-center>
          <v-flex xs6 md4 lg4>
            <v-img src="@/assets/communicada-color.png"></v-img>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-title primary-title class="justify-center text-xs-center">
        <div class="display-1 grey--text text--darken-3">
          {{ $t("login.title") }}
        </div>
      </v-card-title>

      <v-card-text class="px-4">
        <v-form ref="form" onsubmit="return false;">
          <v-text-field
            v-if="email_field.active"
            id="email"
            color="primary"
            :label="$t('rms.field.email.label')"
            name="email"
            placeholder="example@mail.com"
            :rules="[rules.required, rules.email]"
            prepend-icon="email"
            type="text"
            v-model="email_field.value"
            @keyup.enter="onLogin()"
          ></v-text-field>

          <v-text-field
            v-if="otp.active"
            type="tel"
            id="otp"
            color="primary"
            :label="$t('rms.field.otp.label')"
            name="otp"
            :rules="[rules.required, rules.numeric, rules.exact_length(4)]"
            :prepend-icon="$vuetify.icons.rms_otp"
            persistent-hint
            :hint="$t('login.otp.sent.message')"
            v-model="otp.value"
            @keyup.enter="verifyOtp()"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center text-xs-center">
        <v-btn
          v-if="email_field.button.active"
          :loading="email_field.button.loading"
          @click="onLogin"
          large
          :style="{ width: '30%' }"
          color="primary"
          dark
          >{{ $t("rms.button.login") }}</v-btn
        >

        <v-btn
          v-if="otp.active"
          :loading="otp.button.loading"
          color="primary"
          large
          :style="{ width: '30%' }"
          dark
          @click="verifyOtp"
          >{{ $t("rms.button.verify") }}</v-btn
        >
      </v-card-actions>
      <v-card-actions class="justify-center text-xs-center py-4">
        <span class="subheading blue--text">
          {{ $t("quickrights.register.message") }}
          <router-link to="/register" class="success--text">{{
            $t("quickrights.register_now.title")
          }}</router-link>
        </span>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import rules from "@/validation";
import i18n from "@/i18n";
import { mapState } from "vuex";
export default {
  data() {
    return {
      rules,
      email_field: {
        active: true,
        value: "",
        button: {
          active: true,
          loading: false,
        },
      },
      otp: {
        active: false,
        value: "",
        button: {
          loading: false,
        },
      },
    };
  },

  computed: {
    ...mapState({
      session_key: (state) => state.auth.key,
    }),
  },

  methods: {
    activeOtpField() {
      this.otp.active = true;
      this.otp.value = "";
      this.email_field.button.active = false;
    },

    activeEmailField() {
      this.otp.active = false;
      this.otp.button.loading = false;
      this.email_field.button.active = true;
      this.email_field.button.loading = false;
    },

    // sending OTP
    async onLogin() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.email_field.button.loading = true;
      try {
        var data = await this.$store.dispatch("auth/login", {
          email: this.email_field.value,
        });
        this.activeOtpField();

        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.otp.sent"),
          color: "success",
        });
      } catch (error) {
        this.activeEmailField();
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    // verifying otp
    async verifyOtp() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.otp.button.loading = true;
      try {
        var data = await this.$store.dispatch("auth/verifyOtp", {
          otp: this.otp.value,
          key: this.session_key,
        });
        this.otp.button.loading = false;
        await this.$store.dispatch("auth/loginSuccess", data);
      } catch (error) {
        this.activeEmailField();
        this.$store.dispatch("app/showMessage", {
          message:
            error.message || i18n.t("screener.admin.verify_otp.default_error"),
          color: "error",
        });
      }
    },
  },
};
</script>
<style scoped>
.card-style {
  border-radius: 10px !important;
  border-top: 5px solid #5ba2ee !important;
}
</style>
